// Copilot 0.1

import { router } from "./frontend/scripts/router.js";
import createApp from "@shopify/app-bridge";
import { getSessionToken } from "@shopify/app-bridge/utilities";

const content = document.getElementById("content");
const queryString = window.location.search;
const reloadInnerHtmlEvent = new CustomEvent('content-changed');

document.addEventListener("DOMContentLoaded", function(){
	view("dashboard");
    //console.log(window['app-bridge']);
    //var AppBridge = window.AppBridge;
    //console.log(AppBridge);
});

function initializeAppBridge() {
    console.log("initialize");
    view("dashboard");
}

// Función que ejecuta la verificación cada 500ms
function checkAppBridgeLoaded() {
    console.log("initialize");
    if (typeof window['app-bridge'] !== 'undefined') {
        initializeAppBridge(); // Llamar a la función cuando App Bridge esté disponible
    } else {
        // Si App Bridge no está cargado, intenta de nuevo después de 500ms
        setTimeout(checkAppBridgeLoaded, 500);
    }
}

// Comienza a verificar si App Bridge se ha cargado
//setTimeout(checkAppBridgeLoaded, 500);

document.addEventListener("click", function(e) {
	var element = e.target.closest('[page-link]');
	if(element) {
		view(element.getAttribute("page-link"));		
	} else {
		element = e.target.closest('[external-link]');
		if(element) {
			redirect(element.getAttribute("external-link"));
		} else {
            element = e.target.closest('[form-link]');
            if(element) {
                if (element.getAttribute("form-link") == "login") {
                    var email = document.getElementById("email").value;
                    var password = document.getElementById("password").value;
                    makeAPIRequest(queryString, {
                        "action": element.getAttribute("form-link"),
                        "email": email,
                        "password": password
                    }, function (response) {
                        content.innerHTML = router(response);
                    });
                } else {
                    if (element.getAttribute("form-link") == "register") {
                        let error = false;
                        //************//
                        var company = document.getElementById("company");
                        if(company.value != undefined && company.value != "") {
                            company.parentElement.classList.remove('Polaris-TextField--error');
                            document.getElementById("companyError").style.display = 'none';
                        } else {
                            error = true;
                            company.parentElement.classList.add('Polaris-TextField--error');
                            document.getElementById("companyError").style.display = 'flex';
                        }
                        //************//
                        var phone = document.getElementById("phone");
                        if(phone.value != undefined && phone.value != "") {
                            phone.parentElement.classList.remove('Polaris-TextField--error');
                            document.getElementById("phoneError").style.display = 'none';
                        } else {
                            error = true;
                            phone.parentElement.classList.add('Polaris-TextField--error');
                            document.getElementById("phoneError").style.display = 'flex';
                        }
                        //************//
                        var email = document.getElementById("email");
                        var hasErrors = validateEmail(email.value);
                        if (hasErrors) {
                            email.parentElement.classList.add('Polaris-TextField--error');
                            error = true;
                        } else {
                            email.parentElement.classList.remove('Polaris-TextField--error');
                        }
                        //************//
                        var password = document.getElementById("password");
                        var hasErrors = passwordValidation(password.value);
                        if (hasErrors) {
                            error = true;
                            password.parentElement.classList.add('Polaris-TextField--error');
                        } else {
                            password.parentElement.classList.remove('Polaris-TextField--error');
                        }
                        //************//
                        var confirmPassword = document.getElementById("confirm-password");
                        if(
                            confirmPassword.value != undefined &&
                            confirmPassword.value != "" &&
                            confirmPassword.value == password.value) {
                            confirmPassword.parentElement.classList.remove('Polaris-TextField--error');
                            document.getElementById("confirm-passwordError").style.display = 'none';
                        } else {
                            error = true;
                            confirmPassword.parentElement.classList.add('Polaris-TextField--error');
                            document.getElementById("confirm-passwordError").style.display = 'flex';
                        }
                        //************//
                        var legal = document.getElementById("legal");
                        if(legal.checked){
                            legal.parentElement.classList.remove('Polaris-Checkbox--error');
                            document.getElementById("legalError").style.display = 'none';
                        } else {
                            error = true;
                            legal.parentElement.classList.add('Polaris-Checkbox--error');
                            document.getElementById("legalError").style.display = 'flex';
                        }
                        //************//
                        if(error == false) {
                            makeAPIRequest(queryString, {
                                "action": element.getAttribute("form-link"),
                                "company": company.value,
                                "phone": phone.value,
                                "email": email.value,
                                "password": password.value,
                                "confirmPassword": confirmPassword.value,
                                "legal": legal.value,
                            }, function (response) {
                                content.innerHTML = router(response);
                            });
                        }
                    } else {
                        console.log("error");
                    }
                }
            } else {
                element = e.target.closest('[dismiss]');
                //console.log(element.getAttribute("dismiss"));
                if(element) {
                    document.getElementById(element.getAttribute("dismiss")).style.display = 'none';
                }
            }
        }
	}
});

function validateEmail(value) {
    let hasErrors = false;

    // Función interna para mostrar/ocultar mensajes de error y añadir/quitar la clase de error
    function toggleError(isValid, errorElement) {
        errorElement.style.display = isValid ? 'none' : 'flex';
        if (!isValid) {
            hasErrors = true;
        }
    }

    // Check symbol
    toggleError(containsEmail(value), document.getElementById("emailError"));

    return hasErrors;
}

function validateCompany(value) {
    let hasErrors = false;

    // Función interna para mostrar/ocultar mensajes de error y añadir/quitar la clase de error
    function toggleError(isValid, errorElement) {
        errorElement.style.display = isValid ? 'none' : 'flex';
        if (!isValid) {
            hasErrors = true;
        }
    }

    // Check symbol
    toggleError(value.length >= 1, document.getElementById("companyError"));

    return hasErrors;
}

function validatePhone(value) {
    let hasErrors = false;

    // Función interna para mostrar/ocultar mensajes de error y añadir/quitar la clase de error
    function toggleError(isValid, errorElement) {
        errorElement.style.display = isValid ? 'none' : 'flex';
        if (!isValid) {
            hasErrors = true;
        }
    }

    // Check symbol
    toggleError(value.length >= 1, document.getElementById("phoneError"));

    return hasErrors;
}

function view(name, filter = "1") {
	// LOADING	
	content.innerHTML = router();

	var data = {"action": name, "filter": filter};

	// REQUEST
	makeAPIRequest(queryString, data, function(response) {
		content.innerHTML = router(response);
        content.dispatchEvent(reloadInnerHtmlEvent);
		checkDashboardFilters(response);
	});
}

function checkDashboardFilters(response) {
    var responseJSON = JSON.parse(response);
    if (responseJSON!=null) {
        if (responseJSON.data != undefined && responseJSON.data.filter != undefined) {
            const selectedOption = document.getElementById(
                'select-input'
            );
            selectedOption.value = responseJSON.data.filter;
            console.log(selectedOption.value);
            const option = selectedOption.querySelector(
                'option[value="'+responseJSON.data.filter+'"]'
            );
            document.getElementById('selected-option').innerText = option.text;
            document.getElementById('selected-option').setAttribute("data-value", option.value);

        }
    }
}

//TODO: hauria de mirar si la app està embedded o no
function redirect(url) {
	// escape iframe, 
	//window.parent.location.href = url;
    window.open(url, '_blank');
}

function makeAPIRequest(data, action, callback) {
    // Primer s'ha d'autenticar la session token utilitzant app bridge
    //const { createApp } = window.AppBridge;
    //console.log(createApp);
    //var AppBridge = window['app-bridge'];
    //var AppBridgeUtils = window['app-bridge-utils'];
    // GET host param
    var params = new URLSearchParams(data);
    var host = params.get("host");
    if (host) {
        var app = createApp({
            apiKey: '4402cea6f981f7afe1ea33ba55f804c5',
            host: host
        });
        shopifyGetSessionToken(app, data, action, callback);
        /*const sessionToken = await getSessionToken(app);
        var sessionToken = AppBridge.utilities.getSessionToken(app).then(token => {
            if(token) {
                // Request to ACUMEN API
                var xhr = new XMLHttpRequest();
                xhr.open("POST", "api.php", true);
                xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                xhr.setRequestHeader("Authorization", "Bearer " + token);
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === 4 && xhr.status === 200) {
                        callback(xhr.responseText);
                    } else if (xhr.readyState === 4 && xhr.status !== 200) {
                        callback("error");
                    }
                };

                // Datos a enviar en la petición POST
                var payload = prepareData(data, action);
                xhr.send(payload);
            }
        });*/
    } else {
        // redirect ?

    }

    /**/
    //console.log(AppBridge.actions);
    /*const AppBridge = window['app-bridge'];

    const app = AppBridge.createApp({
        apiKey:'xxxxxxx',
        host:'YWRtaW4uc2hvcGlmeS5jb20vc3RvcmUvd2hhdGV2ZXIteW91ci1zdG9yZS1pcy1jYWxsZWQ='
    });

    var sessionToken = await AppBridge.utilities.getSessionToken(app);
    console.log(sessionToken);*/
}

async function shopifyGetSessionToken(app, data, action, callback) {
    try {
        const sessionToken = await getSessionToken(app); // Esperamos que se resuelva la promesa
        console.log('Token de sesión recibido:', sessionToken);

        // Aquí puedes hacer lo que necesites con el sessionToken
        // Por ejemplo, verificar si el token es válido
        if (sessionToken) {
            // Realizar acciones adicionales con el sessionToken
            hacerAlgoConElToken(sessionToken, data, action, callback);
        } else {
            console.log('No se recibió un token de sesión válido.');
        }
    } catch (error) {
        console.error('Error al obtener el token de sesión:', error);
    }
}


function hacerAlgoConElToken(token, data, action, callback) {
    // Request to ACUMEN API
    var xhr = new XMLHttpRequest();
    xhr.open("POST", "api.php", true);
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.setRequestHeader("Authorization", "Bearer " + token);
    xhr.onreadystatechange = function() {
        if (xhr.readyState === 4 && xhr.status === 200) {
            callback(xhr.responseText);
        } else if (xhr.readyState === 4 && xhr.status !== 200) {
            callback("error");
        }
    };

    // Datos a enviar en la petición POST
    var payload = prepareData(data, action);
    xhr.send(payload);
}

/*function shopifyGetSessionToken(element) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve("token123"); // Simulamos un token de autenticación
        }, 2000); // Demora 2 segundos para obtener el token
    });
}*/

//TODO: validate data
function prepareData(rawData, customData) {
    // Traiem ? i afegim action
    rawData = rawData.substring(1);
    Object.keys(customData).forEach(key => {
        rawData += "&"+key+"=" + customData[key];
    });
    console.log(rawData);
	return rawData
}

document.addEventListener('change', function(event) {
    // Verifica si el evento ocurrió en el select específico
    if (event.target && event.target.id === 'select-input') {
        updateSelect(event.target);
    } else {
        // validation remove error classes in register
        if (event.target) {
            if(event.target.type == "checkbox") {
                event.target.parentElement.classList.remove('Polaris-Checkbox--error');
            } else if(event.target.type == "password" || event.target.type == "text") {
                event.target.parentElement.classList.remove('Polaris-TextField--error');
            }
        }
    }
});

function updateSelect(select) {
    const selectedOption = select.options[select.selectedIndex];
    document.getElementById('selected-option').innerText = selectedOption.text;
    document.getElementById('selected-option').setAttribute("data-value", selectedOption.value);
    view("dashboard", selectedOption.value);
}

content.addEventListener('content-changed', function() {
    var company = document.getElementById("company");
    if(company) {
        company.addEventListener("input", function (e) {
            let hasErrors = validateCompany(event.target.value);

            // Añadir o quitar la clase de error en el contenedor
            if (hasErrors) {
                company.parentElement.classList.add('Polaris-TextField--error');
            } else {
                company.parentElement.classList.remove('Polaris-TextField--error');
            }
        });
    }
    var phone = document.getElementById("phone");
    if(phone) {
        phone.addEventListener("input", function (e) {
            let hasErrors = validatePhone(event.target.value);

            // Añadir o quitar la clase de error en el contenedor
            if (hasErrors) {
                phone.parentElement.classList.add('Polaris-TextField--error');
            } else {
                phone.parentElement.classList.remove('Polaris-TextField--error');
            }
        });
    }
    var email = document.getElementById("email");
    if(email) {
        email.addEventListener("input", function (e) {
            let hasErrors = validateEmail(event.target.value);

            // Añadir o quitar la clase de error en el contenedor
            if (hasErrors) {
                email.parentElement.classList.add('Polaris-TextField--error');
            } else {
                email.parentElement.classList.remove('Polaris-TextField--error');
            }
        });
    }
    var password = document.getElementById("password");
    if(password) {
        password.addEventListener("input", function (e) {
            let hasErrors = passwordValidation(event.target.value);

            // Añadir o quitar la clase de error en el contenedor
            if (hasErrors) {
                password.parentElement.classList.add('Polaris-TextField--error');
            } else {
                password.parentElement.classList.remove('Polaris-TextField--error');
            }
        });
    }
    var confirmPassword = document.getElementById("confirm-password");
    if(confirmPassword) {
        confirmPassword.addEventListener("input", function (e) {
            if (confirmPassword.value != undefined && confirmPassword.value != "" && password.value == confirmPassword.value) {
                confirmPassword.parentElement.classList.remove('Polaris-TextField--error');
                document.getElementById("confirm-passwordError").style.display = 'none';
            }
        });
    }
    var legal = document.getElementById("legal");
    if(legal) {
        legal.addEventListener("input", function (e) {
            if(legal.checked){
                legal.parentElement.classList.remove('Polaris-TextField--error');
                document.getElementById("legalError").style.display = 'none';
            }
        });
    }
});

function passwordValidation(value) {
    let hasErrors = false;

    // Función interna para mostrar/ocultar mensajes de error y añadir/quitar la clase de error
    function toggleError(isValid, errorElement) {
        errorElement.style.display = isValid ? 'none' : 'flex';
        if (!isValid) {
            hasErrors = true;
        }
    }

    // Check length
    toggleError(value.length >= 10, document.getElementById("passwordErrorLength"));

    // Check lower
    toggleError(containsLowercase(value), document.getElementById("passwordErrorLower"));

    // Check upper
    toggleError(containsUppercase(value), document.getElementById("passwordErrorUpper"));

    // Check number
    toggleError(containsNumber(value), document.getElementById("passwordErrorNumber"));

    // Check symbol
    toggleError(containsSymbol(value), document.getElementById("passwordErrorSymbol"));

    return hasErrors;
}

// Funciones de validación
function containsEmail(str) {
    return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(str);
}

function containsLowercase(str) {
    return /[a-z]/.test(str);
}

function containsUppercase(str) {
    return /[A-Z]/.test(str);
}

function containsNumber(str) {
    return /[0-9]/.test(str);
}

function containsSymbol(str) {
    return /[!@#$%^&*()_+\-=\[\]{};':",\\|,.<>\/?]/.test(str);
}